export const ADMIN_SUBSCRIPTIONS_OVERVIEW_REFRESH_EVENT =
  'admin-subscriptions-overview:refresh'

export const dispatchAdminSubscriptionsOverviewRefresh = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent(ADMIN_SUBSCRIPTIONS_OVERVIEW_REFRESH_EVENT)
  )
}
